<template>
  <!-- 商城配置 -->
  <div class="mallConfig">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    ></crumbs-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="TypeName"
        label="配置项"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ImgType"
        label="别名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            @click="handleConfig(scope.row)"
            plain
            >配置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 修改 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">修改配置</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="配置名" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item
              v-show="addForm.type == 2 || addForm.type == 1"
              label="配置项"
              prop="config"
            >
              <el-input v-model="addForm.config" clearable></el-input>
            </el-form-item>
            <el-form-item
              v-show="
                addForm.type == 2 ||
                addForm.type == 0 ||
                addForm.name == '订购热线'
              "
              label="图片"
              prop="image"
            >
              <img-view :imgList="[{ url: imgUrl, id: 0 }]"> </img-view>
              <upload
                @fileChange="uploadSuccess"
                accept="image/jpg,image/jpeg,image/png"
              >
              </upload>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="sureModify">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "mallConfig",
  data() {
    return {
      /**表格数据 */
      //序号	配置项	别名	排序	操作
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**新增管理员drawer */
      addDrawer: false,
      /**表单数据 */
      //配置名 配置项
      addForm: {
        id: "",
        type: "",
        name: "",
        config: "",
        imgUrl: "",
      },
      imgUrl: "",
      addFormRule: {
        name: [mustFill],
      },
    };
  },
  components: {
    // ImgUpload
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData() {
      let data = {
        type: "PC_GetImgType",
        status: 2,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      var proc = "Pc_Log"; //存储过程名
      var type = "ReturnList";
      ///加载页面数据
      this.$requestSys({
        method: "post",
        url:
          "configuration/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    uploadSuccess(file) {
      if (file.length) {
        //将上传的图片file对象直接转化为blob地址，无需重新获取商品详情
        this.imgUrl = URL.createObjectURL(file[0]);
      }
      let formData = new FormData();
      file.forEach((ele, index) => {
        formData.append("file" + index, ele);
      });
      this.$uploadRequest({
        url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=zhuanqu",
        method: "post",
        data: formData,
      })
        .then((res) => {
          this.addForm.imgUrl = res.message;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    handleConfig(row) {
      console.log(row, "2323");
      this.clearForm();
      this.addForm.type = row.ImgOrText;
      this.getMallConfig(row);
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    // 获取单个详细信息
    getMallConfig(row) {
      let json = {
        type: "PC_GetWebConfigValue",
        id: row.ID,
      };
      let proc = "Pc_Log"; //存储过程名
      let type = "ReturnList";
      ///加载页面数据
      this.$requestSys({
        method: "post",
        url:
          "configuration/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.addForm.id = res.data[0].ID;
            this.addForm.name = res.data[0].TypeName;
            this.addForm.config = res.data[0].WebValue;
            this.addForm.imgUrl = res.data[0].imgurl;
            this.imgUrl = this.$setImgUrl(res.data[0].imgurl);
            this.addDrawer = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 确认修改
    sureModify() {
      let data = {
        type: "PC_AddWebConfig",
        id: this.addForm.id,
        imgurl: this.addForm.imgUrl,
        webvalue: this.addForm.config,
        Name: this.addForm.name,
      };
      let proc = "Pc_Log"; //存储过程名
      let type = "ReturnNumber";
      ///加载页面数据
      this.$requestSys({
        method: "post",
        url:
          "rechargeorder/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
            this.clearForm();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.mallConfig {
  width: 100%;
  height: 100%;
}
</style>
